import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  // Check localStorage for saved preference, default to 'light' (premium light-first design)
  var getInitialTheme = function() {
    if (typeof window !== 'undefined') {
      var saved = localStorage.getItem('servio-theme');
      if (saved === 'light' || saved === 'dark') {
        return saved;
      }
    }
    return 'dark';
  };

  var themeState = useState(getInitialTheme);
  var theme = themeState[0];
  var setThemeState = themeState[1];

  // Apply theme class to document
  useEffect(function() {
    var root = document.documentElement;
    if (theme === 'light') {
      root.classList.add('light-theme');
      root.classList.remove('dark-theme', 'dark');
    } else {
      root.classList.add('dark-theme', 'dark');
      root.classList.remove('light-theme');
    }
    localStorage.setItem('servio-theme', theme);
  }, [theme]);

  var setTheme = function(newTheme) {
    setThemeState(newTheme);
  };

  var toggleTheme = function() {
    setThemeState(function(prev) {
      return prev === 'dark' ? 'light' : 'dark';
    });
  };

  var value = {
    theme: theme,
    setTheme: setTheme,
    toggleTheme: toggleTheme,
    isDark: theme === 'dark',
    isLight: theme === 'light'
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  var context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
